module.exports = __webpack_public_path__ + "static/index_crop.766eb41f.jpg";